// Import custom scripts and files
import './plugins/Craft';
import Alpine from 'alpinejs';
import initHeightCard from './components/HeightCard';
import initSwiper from './components/Swiper';
import initJsStyles from './components/JsStyles';
import videoDialog from './components/VideoDialog';
import initPhotoSwipeLightbox from './components/PhotoSwipeLightbox';
import initDialog from './components/Dialog';
import initHeader from './components/Header';
import initSimpleMenu from './components/SimpleMenu';
import initAccordion from './components/Accordion';
import initVideoHero from './components/VideoHero';
import initCopyToClipboard from './components/CopyToClipboard';
import initStickySidebar from './components/StickySidebar';
import initOpenClose from './components/OpenClose';

window.videoDialog = videoDialog;

window.Alpine = Alpine;

document.addEventListener('alpine:init', () => {
  initJsStyles();
  initHeightCard();
  initSwiper();
  initPhotoSwipeLightbox();
  initDialog();
  initHeader();
  initSimpleMenu();
  initAccordion();
  initVideoHero();
  initCopyToClipboard();
  initStickySidebar();
  initOpenClose();
});
Alpine.start();

document.body.addEventListener('htmx:load', () => {
  htmx.on('htmx:afterSwap', () => {
    initStickySidebar();
  });
});
